"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uuidv4 = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
        var random = Math.random() * 16 | 0;
        var uuid = char === 'x' ? random : (random & 0x3 | 0x8);
        return uuid.toString(16);
    });
};
